import {inject, Injectable} from "@angular/core";
import {ProfilesGroupActionsStrategyInterface} from "./profiles-group-actions-strategy.interface";
import {FxDealsCancellationService} from "./fx-deals-cancellation.service";
import {ProfilesGroupActionService} from "./profiles-group-action.service";
import {DataService} from "@fgpp-ui/components";
import {FnUiDialogService} from "../../shared/fn-ui-dialog/services/fn-ui-dialog.service";

Injectable()
export class ProfileGroupActionsStrategySelectionService {

  private profileGroupService =  inject(ProfilesGroupActionService);
  private strategies: Map<string, ProfilesGroupActionsStrategyInterface> = new Map<string, ProfilesGroupActionsStrategyInterface>();

  constructor() {
    this.strategies.set('978', new FxDealsCancellationService() );
  }
  public getStrategy(profileId: string): ProfilesGroupActionsStrategyInterface {
    return this.strategies.get(profileId) || this.profileGroupService;
  }

}
